// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"464":"dcd596affca63be4","913":"1ce0baebc5ba334d"}[chunkId] + ".js";
};